import _ from 'lodash';
import { Moment } from 'moment';
import * as React from 'react';
import { createInitialAttendanceState, isWeekend } from '.';
import Icons from '../../../../../../common/widgets/Icons';
import {
  IndexedArray,
  IndexedTimesheet,
  Timesheet,
} from '../../../../models/TimeAndAttendance';

interface IMobileTimeAndAttendanceCalendarProps {
  calendarDays: (
    | IndexedArray[]
    | {
        weekDay: string | undefined;
        index: number;
      }
  )[];
  firstDayOfMonthIndex: number;
  isTimesheetBlocked: boolean;
  setShowAttendanceDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedAttendance: React.Dispatch<
    React.SetStateAction<Timesheet | undefined>
  >;
  currentDate: Moment;
  handleSelectEmptyAttendace: (
    currentDate: Moment,
    calendarDay: IndexedTimesheet,
  ) => void;
}

export const MobileTimeAndAttendanceCalendar = (
  props: IMobileTimeAndAttendanceCalendarProps,
) => {
  const renderAttendance = (
    calendarDay: Timesheet & { index: number; weekDay: string },
  ) => {
    if (calendarDay.presenceType) {
      return (
        <button
          type="button"
          disabled={props.isTimesheetBlocked}
          onClick={() => {
            props.setSelectedAttendance({
              ...calendarDay,
              startDate: new Date(calendarDay.startDate),
              endDate: new Date(calendarDay.endDate),
              workEvent: {
                ...createInitialAttendanceState(null).workEvent,
                ...calendarDay.workEvent,
              },
              files: calendarDay.files ?? [],
            });
            props.setShowAttendanceDialog(true);
          }}
          className="taa-calendar-day-event"
          style={{
            backgroundColor: `#${calendarDay.presenceType.highlightColor}`,
            color: `#${calendarDay.presenceType.textColor}`,
          }}
        >
          {calendarDay.presenceType.presenceTypeDescription}
        </button>
      );
    }

    if (props.isTimesheetBlocked) {
      return null;
    }

    return (
      <button
        type="button"
        className="taa-calendar-day-empty"
        onClick={() => {
          props.handleSelectEmptyAttendace(props.currentDate, calendarDay);
        }}
      >
        <Icons.ProductAdd />
      </button>
    );
  };

  return (
    <React.Fragment>
      {_.map(
        props.calendarDays,
        (calendarDay: Timesheet & { index: number; weekDay: string }) => (
          <div
            key={`${calendarDay.index}_${calendarDay.weekDay}`}
            className={`taa-calendar-day ${
              isWeekend(calendarDay.index, props.firstDayOfMonthIndex)
                ? 'inactive'
                : 'active'
            }`}
          >
            <div className="taa-calendar-weekday">{calendarDay.weekDay}</div>
            <div className="taa-calendar-day-content">
              {calendarDay && calendarDay.index > 0 && (
                <>
                  <div>{calendarDay.index}</div>
                  {renderAttendance(calendarDay)}
                </>
              )}
            </div>
          </div>
        ),
      )}
    </React.Fragment>
  );
};
